import { Link } from "react-router-dom";

interface MediaCardProps {
  id: string;
  title: string;
  year?: number;
  cover: string;
  summary: string;
  tags: string[];
  rating?: number;
  rank?: number;
}

export default function MediaCard({ id, title, year, cover, summary, tags, rating, rank }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100/70 transition-colors duration-300 hover:border-primary-500/60"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={cover}
          alt={`${title} 海报`}
          title={`${title}${year ? ` ${year}` : ""} - 夜无疆影视大全`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-background-50/95 to-transparent" />
        {typeof rating === "number" && (
          <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-background-50/85 px-2 py-1 text-xs font-semibold text-accent-400">
            <i className="ri-star-fill text-[11px]" />
            {rating.toFixed(1)}
          </span>
        )}
        {typeof rank === "number" && (
          <span
            className={`absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-md font-heading text-sm font-bold ${
              rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-50/85 text-foreground-800"
            }`}
          >
            {rank}
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3 md:p-4">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 md:text-base">
          {title}
        </h3>
        <div className="flex flex-wrap items-center gap-1.5">
          {year && <span className="text-xs text-foreground-500">{year}</span>}
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-950"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="line-clamp-2 text-xs leading-6 text-foreground-600">{summary}</p>
      </div>
    </Link>
  );
}